import type { DashboardContentProps } from 'src/layouts/dashboard';

import { removeLastSlash } from 'minimal-shared/utils';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { DashboardContent } from 'src/layouts/dashboard';

import { Iconify } from 'src/components/iconify';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { useAuth } from '../../auth/context/auth-context';
import { RoleType } from '../../types/user';

// ----------------------------------------------------------------------

export function AccountLayout({ children, ...other }: DashboardContentProps) {
  const pathname = usePathname();
  const { user } = useAuth();

  const isConsulente = user?.role === RoleType.Consulente;

  const NAV_ITEMS = [
    {
      label: 'Dati personali',
      icon: <Iconify width={24} icon="solar:user-id-bold" />,
      href: paths.dashboard.account.root,
    },
    ...(isConsulente
      ? [
        {
          label: 'Impostazioni Grafiche',
          icon: <Iconify width={24} icon="solar:palette-bold" />,
          href: paths.dashboard.account.settingsUIConsulenti,
        },
      ]
      : []),
    {
      label: 'Notifiche',
      icon: <Iconify width={24} icon="solar:bell-bing-bold" />,
      href: paths.dashboard.account.notifications,
    },
    {
      label: 'Sicurezza',
      icon: <Iconify width={24} icon="ic:round-vpn-key" />,
      href: paths.dashboard.account.changePassword,
    },
  ];

  // il Beginner vede solo "Sicurezza"
  const navItems =
    user?.role === RoleType.Beginner
      ? NAV_ITEMS.filter((tab) => tab.href === paths.dashboard.account.changePassword)
      : NAV_ITEMS;

  return (
    <DashboardContent {...other}>
      <CustomBreadcrumbs
        heading="Account"
        links={[
          { name: 'Home', href: paths.dashboard.root },
          { name: 'Account' },
        ]}
        sx={{ mb: 3 }}
      />

      <Tabs value={removeLastSlash(pathname)} sx={{ mb: { xs: 3, md: 5 } }}>
        {navItems.map((tab) => (
          <Tab
            component={RouterLink}
            key={tab.href}
            label={tab.label}
            icon={tab.icon}
            value={tab.href}
            href={tab.href}
          />
        ))}
      </Tabs>

      {children}
    </DashboardContent>
  );
}
